import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Chip,
  debounce,
} from "@mui/material";
import { styled } from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  fetchUserGoalData,
  fetchUserGoalDataScroll,
  fetchUserGoalDataSearch,
} from "../../../action/userGoals";
import { isArray } from "jquery";
import GoalComponent from "./GoalComponent";
import VideoSkeleton from "./VideoSkeleton";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";
import CategoryComponent from "../CategoryComponent/Index";
import { useDebounce } from "../../../hooks/useCustomDebounce";
import ClubGoalComponent from "./ClubGoalComponent";
import ClubListing from "./ClubListing";
import { getAllClubsApi } from "../../../features/allClubs.slice";

const GoalVideos = () => {
  const token = useSelector((state) => state.auth.token);
  const goalsData = useSelector((state) => state.userGoals);
  const goalCategories = useSelector((state) => state.goalCategories);
  const allClubGoals = useSelector((state) => state.allClubs);
  const [goal, setGoal] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const [subFilter, setSubFilter] = useState("");
  const [childFilter, setChildFilter] = useState("");
  const loadMoreRef = useRef(null);
  const [scrollLoading, setScrollLoading] = useState(false);
  const [noMoreMessage, setNoMoreMessage] = useState(false);
  const page = useRef(1);
  const globalSearchState = useSelector((state) => state.globalSearch);
  const goalsRef = useRef([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const share = searchParams.get("share");

  const [clubData, setClubData] = useState([]);

  const fetchSearchResult = useCallback(
    (token, filter, key, subFilter, childFilter) => {
      // if (api == "home" || api == "goals") {
      page.current = 1;
      dispatch(
        fetchUserGoalDataSearch(token, filter, 1, key, {
          subFilter,
          childFilter,
        }),
      );
      // }
    },
    [],
  );

  const debouncedFunc = useDebounce(fetchSearchResult, 500);

  useEffect(() => {
    if (globalSearchState.search !== "" && token) {
      // fetchSearchResult(globalSearchState.search, globalSearchState.api);
      debouncedFunc(
        token,
        filter,
        globalSearchState.search,
        subFilter,
        childFilter,
      );
    }
  }, [globalSearchState]);

  useEffect(() => {
    if (token) {
      page.current = 1;
      dispatch(fetchUserGoalData(token, ""));
    }
  }, []);

  useSkipFirstRender(() => {
    if (goalsData.filter == "refresh") {
      setFilter("");
      setSubFilter(null);
      setChildFilter(null);
    }
  }, [goalsData]);

  useSkipFirstRender(() => {
    if (token) {
      if (filter == "AllClubs") {
        // setClubData(
        //   allClubGoals.data?.filter((data) => data.ClubGoals.length > 0),
        // );
        dispatch(getAllClubsApi(token));
        page.current = 1;
        setScrollLoading(false);
      } else {
        page.current = 1;
        dispatch(fetchUserGoalData(token, filter));
      }
    }
  }, [filter]);

  useSkipFirstRender(() => {
    if (token && childFilter) {
      page.current = 1;
      dispatch(
        fetchUserGoalData(token, filter, "", { subFilter, childFilter }),
      );
    }
  }, [childFilter]);

  useSkipFirstRender(() => {
    if (token && subFilter) {
      page.current = 1;
      dispatch(
        fetchUserGoalData(token, filter, "", { subFilter, childFilter }),
      );
    }
  }, [subFilter]);

  useEffect(() => {
    setLoading(goalsData.loading);

    if (filter == "AllClubs") return;

    // goal search state
    if (globalSearchState.search.trim() !== "") {
      if (goalsData?.search.success) {
        setGoal(goalsData?.search?.data);
        setScrollLoading(false);
      }
    } else {
      // goal state
      if (goalsData?.data?.success) {
        if (goalsData?.data?.data.length > 0) {
          setGoal([...goalsData?.data?.data, ...goalsData?.addData]);
          setScrollLoading(false);
        } else {
          setGoal([]);
          setScrollLoading(false);
        }
      }
    }

    if (goalsData?.error) {
      setGoal([]);
      setScrollLoading(false);
    }
  }, [goalsData, globalSearchState]);

  /// for user scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          if (!goalsData.hasMore) {
            if (share) {
              searchParams.delete("share");
              toast.error("Post not found!!");
            }
            setNoMoreMessage(true);
            setTimeout(() => {
              setNoMoreMessage(false);
            }, 2000);
            return;
          }
          setScrollLoading(true);

          page.current++;
          if (
            globalSearchState.api == "home" ||
            globalSearchState.api == "goals"
          ) {
            dispatch(
              fetchUserGoalDataScroll(
                token,
                filter,
                page.current,
                globalSearchState.search,
                { childFilter, subFilter },
              ),
            );
          } else {
            dispatch(
              fetchUserGoalDataScroll(
                token,
                filter,
                page.current,
                globalSearchState.search,
                {
                  subFilter,
                  childFilter,
                },
              ),
            );
          }
        }
      },
      {
        threshold: 0.5,
      },
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [goal]);

  useEffect(() => {
    if (!isNaN(share) && share !== null && !loading) {
      setTimeout(() => {
        const shareGoalId = goalsRef.current.filter((obj) => {
          return obj.id == share;
        });
        if (shareGoalId.length > 0) {
          shareGoalId[0].element?.scrollIntoView({ behavior: "smooth" });
          if (searchParams) {
            searchParams.delete("share");
          } else {
          }
        } else {
          loadMoreRef.current?.scrollIntoView({ behavior: "smooth" });
        }
      }, [1000]);
    } else {
    }
  }, [share, loading, goal]);


  return (
    <>
      <Box className="Goal-video-main">
        <Box className="wrapper">
          {goalCategories.loading ? (
            <CircularProgress />
          ) : Array.isArray(goalCategories.data?.data) ? (
            <CategoryComponent
              categories={goalCategories.data?.data}
              filter={filter}
              setFilter={setFilter}
              subFilter={subFilter}
              setSubFilter={setSubFilter}
              childFilter={childFilter}
              setChildFilter={setChildFilter}
              home={"home"}
            />
          ) : (
            "No category data found"
          )}

          {filter == "AllClubs" ? (
            <ClubListing />
          ) : (
            <Box
              className="goal-wrapper"
              sx={{ backgroundColor: "#191b2f", minHeight: "calc( 100vh - " }}
            >
              {loading ? (
                Array.from({ length: 10 }).map((ele, index) => (
                  <VideoSkeleton key={index} />
                ))
              ) : Array.isArray(goal) && goal.length > 0 ? (
                goal.map((ele, index) => {
                  if (index == goal.length - 1) {
                    return (
                      <Box
                        className="goal-main"
                        key={ele.id}
                        ref={(element) => {
                          goalsRef.current[index] = { id: ele.id, element };
                        }}
                        sx={{ backgroundColor: "#242743" }}
                      >
                        <GoalComponent data={ele} />
                        {scrollLoading ? (
                          <Box
                            sx={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "20px",
                            }}
                          >
                            <CircularProgress />
                          </Box>
                        ) : (
                          <div
                            ref={loadMoreRef}
                            className="loadMore"
                            style={{ height: "10px", width: "10px" }}
                          ></div>
                        )}
                        {noMoreMessage ? (
                          <Box
                            sx={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "5px",
                            }}
                          >
                            <Chip
                              variant="outlined"
                              color="warning"
                              label="No More Goals"
                            />
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                    );
                  } else {
                    return (
                      <Box
                        key={ele.id}
                        ref={(element) => {
                          goalsRef.current[index] = { id: ele.id, element };
                        }}
                        className="goal-main"
                        sx={{ backgroundColor: "#242743" }}
                      >
                        <GoalComponent key={index} data={ele} />
                      </Box>
                    );
                  }
                })
              ) : (
                <Box
                  sx={{
                    minHeight: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    component="p"
                    sx={{ color: "#6f7081", fontSize: "28px" }}
                  >
                    No Goal Data Found
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default GoalVideos;
